import {Map, fromJS} from 'immutable'

import {
  SET_CURRENT_USER,
  SET_CURRENT_USER_PRESENCE,
  SET_CURRENT_USER_ACTIVITY
} from '../action_types'

import currentUserPresenceReducer from './current_user_presence'

export default (state = Map(), action) => {
  switch(action.type) {
    case SET_CURRENT_USER:
      if (action.user) {
        const user = fromJS(action.user).delete('presence')
        return state.merge(user)
      }
      else {
        return Map()
      }

    case SET_CURRENT_USER_PRESENCE:
      if (typeof(action.presence) === 'number') {
        return state.set(
          'presence',
          currentUserPresenceReducer(state.getIn('presence'), action)
        )
      }

    case SET_CURRENT_USER_ACTIVITY:
      return state.set('isActive', action.isActive)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/current_user.js
 **/